module["exports"] = ["straat", "laan", "weg", "dreef", "plein", "park"];